<script lang="ts" setup>
import { computed } from "vue";

import { TableCell } from "./ui/table";
import AutoTable from "./ui/table/AutoTable.vue";
import TableRow from "./ui/table/TableRow.vue";
import { groupTypes } from "../i18n/helpers.ts";

import { useStrongTypedI18n } from "../i18n/useStrongTypedI18n.ts";

const { t } = useStrongTypedI18n();

const props = defineProps({
  users: {
    type: Array,
    required: true,
  },
  groups: {
    type: Array,
    required: true,
  },
});

const groupCols = [
  { key: "Name", label: "Name", sortable: false },
  { key: "Type", label: "Type", sortable: false },
  { key: "Description", label: "Description", sortable: false },
  { key: "UserCount", label: "Users", sortable: false, cellClass: "text-right", headClass: "text-right" },
];

const groupRows = computed(() =>
  props.groups.map((data) => ({
    Name: data.Name,
    Type: groupTypes(t)[data.Type](),
    Description: data.Description,
    UserCount: data.UserIDs ? data.UserIDs.length : 0,
  })),
);

const userCols = [
  { key: "Name", label: "Name", sortable: false },
  { key: "Company", label: "Company", sortable: false },
  { key: "UserName", label: "Username", sortable: false, cellClass: "text-right", headClass: "text-right" },
];

const userRows = computed(() =>
  props.users.map((data) => ({
    Name: data.Name,
    Company: data.Company || "-",
    UserName: data.UserName,
  })),
);
</script>

<template>
  <div
    data-testid="assignments-card"
    class="flex flex-col space-y-6 rounded-lg border bg-background p-6 shadow-sm transition-colors"
  >
    <h3 class="scroll-m-20 text-2xl font-semibold tracking-tight">
      {{ t("common.assignments") }}
    </h3>

    <div class="space-y-4">
      <h4 class="scroll-m-20 text-xl font-semibold tracking-tight">{{ t("common.groups") }}</h4>

      <AutoTable :columns="groupCols" :rows="groupRows">
        <template #default>
          <TableRow>
            <TableCell colspan="3" class="text-center text-muted-foreground">
              {{ t("pages.wizard.steps.users.groups.empty.preview") }}
            </TableCell>
          </TableRow>
        </template>
      </AutoTable>
    </div>

    <hr />
    <div class="space-y-4">
      <h4 class="scroll-m-20 text-xl font-semibold tracking-tight">{{ t("common.users") }}</h4>

      <AutoTable :columns="userCols" :rows="userRows" data-testid="users-table">
        <template #default>
          <TableRow>
            <TableCell colspan="3" class="text-center text-muted-foreground">
              {{ t("pages.wizard.steps.users.users.empty.preview") }}
            </TableCell>
          </TableRow>
        </template>
      </AutoTable>
    </div>
  </div>
</template>
